export const getStyled = () => ({
  contactsHeader: {
    display: 'flex',
    alignItems: 'center',
    padding: '0px 6px 6px 6px',
  },
});
